import React, { useEffect, useState } from "react";

import styles from "./FormStep1.module.scss";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";
import { OptionsProps } from "../../types/order";
import { selectStyles } from "../../static/styles";
import { useAppSelector } from "../../app/hooks";
import { getParties } from "../../features/newOrder/newOrderSlice";
import { PartyProps } from "../../types/party";

const FormStep1 = () => {
  const parties = useAppSelector(getParties);

  const {
    register,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const [partiesOption, setPartiesOption] = useState<OptionsProps[]>([]);

  const handleChangeParty = async (party_id: number) => {
    if (party_id) {
      setValue("party_id", party_id);
      clearErrors("party_id");
    }
  };

  useEffect(() => {
    setPartiesOption(
      parties?.map((party: PartyProps) => ({
        value: party.id,
        label:
          party.firm_name +
          (party.name ? " - " + party.name : "") +
          (party.phone ? " (" + party.phone + ")" : ""),
      })) || []
    );
  }, [parties]);

  return (
    <div className={styles.FormStep1}>
      <div className="mt-6">
        <label className="text-primary-1 font-bold">પાર્ટી :</label>
        <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
          <Controller
            {...register("party_id", { required: true })}
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={partiesOption.find((val) => val.value === field?.value)}
                className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                styles={selectStyles}
                placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                options={partiesOption}
                onChange={(val: any) => handleChangeParty(val?.value)}
              />
            )}
          />
        </div>
        {errors.party_id && errors.party_id.type === "required" && (
          <span className="text-red-500">પાર્ટી નું નામ સિલેક્ટ કરો</span>
        )}
      </div>
    </div>
  );
};
export default FormStep1;
